import { createActionGroup, props } from '@ngrx/store';
import { DEPARTMENTS_FEATURE_KEY } from './departments.selectors';
import {
  AddUsersMembershipProps,
  CreateDepartmentProps,
  CreateDepartmentSuccessProps,
  GetDepartmentMembershipsProps,
  GetDepartmentsProps,
  GetDepartmentsSuccessProps,
  RemoveUserMembershipProps,
  UpdateDepartmentMemberships,
  UpdateDepartmentProps,
  UpdateDepartmentSuccessProps,
  UpdateDepartmentUserProps,
} from './models/props/departments.props';

export const departmentsActions = createActionGroup({
  source: DEPARTMENTS_FEATURE_KEY,
  events: {
    'Ensure client departments': props<GetDepartmentsProps>(),
    'Get departments': props<GetDepartmentsProps>(),
    'Get departments success': props<GetDepartmentsSuccessProps>(),
    'Get department memberships': props<GetDepartmentMembershipsProps>(),
    'Get department memberships success': props<UpdateDepartmentMemberships>(),
    'Update department memberships success': props<UpdateDepartmentMemberships>(),
    'Update department': props<UpdateDepartmentProps>(),
    'Update department success': props<UpdateDepartmentSuccessProps>(),
    'Create department': props<CreateDepartmentProps>(),
    'Create department success': props<CreateDepartmentSuccessProps>(),
    'Update department user': props<UpdateDepartmentUserProps>(),
    'Update department user success': props<UpdateDepartmentUserProps>(),
    'Add users membership Success': props<AddUsersMembershipProps>(),
    'Remove user membership': props<RemoveUserMembershipProps>(),
  },
});
